import moment from "moment";
import React, { useEffect, useState } from "react";
import { useTable } from "react-table";
import "./datagrid/print.css";
import Printcomp from "./printcomp";
const GeniusTableForReports = ({
  columns,
  data,
  title,
  Fotter,
  headerWidth,
  customeHeader,
  filteredData,
}) => {
  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    useTable({ columns, data });

  const companyName = localStorage.getItem("company");
  const [finalFilterData, setFinalFilterData] = useState([]);
  const [TotalFilterData, setTotalFilterData] = useState([]);
  const totalAmt = data.reduce((acc, row) => acc + Number(row.AMOUNT), 0);
  useEffect(() => {
    setTotalFilterData(
      rows[0]
        ? filteredData
          ? [
              ...rows,
              {
                ...rows[0],
                values: {
                  ...rows[0].values,
                  ITEMNAME: "Total...",
                  SECTION_NAME: "",
                  ICODE: "",
                  QNTY: data.reduce((acc, row) => acc + Number(row.QNTY), 0),
                  AMOUNT: data
                    .reduce((acc, row) => acc + Number(row.AMOUNT), 0)
                    .toFixed(2),
                  TAX1_AMT: data
                    .reduce((acc, row) => acc + Number(row.TAX1_AMT), 0)
                    .toFixed(2),
                  TAX2_AMT: data
                    .reduce((acc, row) => acc + Number(row.TAX2_AMT), 0)
                    .toFixed(2),
                  TAX3_AMT: data
                    .reduce((acc, row) => acc + Number(row.TAX3_AMT), 0)
                    .toFixed(2),
                  TAX1_RATE: "",
                  TAX2_RATE: "",
                  GTOTAL: data
                    .reduce((acc, row) => acc + Number(row.GTOTAL), 0)
                    .toFixed(2),
                  TAX3_RATE: "",
                  PUR_PRICE: "",
                  DISQ_AMT: data
                    .reduce((acc, row) => acc + Number(row.DISQ_AMT), 0)
                    .toFixed(2),
                },
              },
            ]
          : []
        : []
    );
  }, [rows, finalFilterData, filteredData]);

  useEffect(() => {
    let listtt = filteredData
      ? filteredData[0]
        ? [
            ...filteredData,
            {
              SECTION_NAME: "TOTAL..",
            },
          ]
        : []
      : [];
    setFinalFilterData(listtt);
  }, [filteredData]);

  return (
    <div
      id="main"
      style={{ width: "100%", height: "100%", backgroundColor: "white" }}
    >
      <div
        id="print-component"
        className={`${headerWidth ? `pt-[0px]` : ""} px-4`}
        style={
          window.innerWidth < 600
            ? {
                width: "100%",
                height: "auto",
                overflow: "hidden",
              }
            : {
                width: "100%",
                height: "auto",
                overflow: "hidden",
              }
        }
      >
        <div className="flex flex-col justify-center items-center mb-3">
          <div className="font-semibold text-[18px]">{companyName}</div>
          <div>{title}</div>
          <div>{customeHeader ? customeHeader : <div className=""></div>}</div>
        </div>
        <table
          {...getTableProps()}
          style={{ border: "1px solid black" }}
          className="w-full"
        >
          <thead>
            {headerGroups.map((headerGroup, key) => (
              <tr
                key={key}
                style={{ fontSize: "12px" }}
                {...headerGroup.getHeaderGroupProps()}
              >
                {headerGroup.headers.map((column, index) => (
                  <td
                    {...column.getHeaderProps()}
                    className=" text-center py-2  overflow-hidden"
                    style={
                      columns[index].width
                        ? {
                            width: columns[index].width,
                            fontWeight: 500,
                            borderRight: "1px solid black",
                            borderBottom: "1px solid black",
                          }
                        : {
                            flex: columns[index].flex,
                            fontWeight: 500,
                            borderRight: "1px solid black",
                            borderBottom: "1px solid black",
                          }
                    }
                    key={index}
                  >
                    {columns[index].renderHeader().props.children}
                  </td>
                ))}
              </tr>
            ))}
          </thead>
          <tbody
            style={{
              border: "1px solid black",
            }}
            className=""
            {...getTableBodyProps()}
          >
            {!filteredData ? (
              rows.map((row, key) => {
                prepareRow(row);

                return (
                  <tr key={key} {...row.getRowProps()}>
                    {row.cells.map((cell, k) => (
                      <td
                        {...cell.getCellProps()}
                        style={{
                          padding: "8px",
                          borderRight: "1px dashed black",
                          borderTop: "1px dashed black",
                          fontSize: "11px",
                        }}
                        key={k}
                      >
                        <div
                          style={{
                            textAlign: cell.render("Cell").props.cell.column
                              .align
                              ? cell.render("Cell").props.cell.column.align
                              : "left",
                          }}
                          className="whitespace-nowrap"
                        >
                          {cell.render("Cell").props.cell.column.type === "date"
                            ? moment(
                                cell.render("Cell").props.cell.value
                              ).format("YYYY-MM-DD")
                            : cell.render("Cell").props.cell.value === "0.00" ||
                              cell.render("Cell").props.cell.value === 0
                            ? null
                            : cell.render("Cell")}
                        </div>
                      </td>
                    ))}
                  </tr>
                );
              })
            ) : (
              <Printcomp
                finalFilterData={finalFilterData}
                TotalFilterData={TotalFilterData}
                prepareRow={prepareRow}
              />
            )}
          </tbody>
        </table>
        <div
          style={{
            width: columns.reduce((acc, row) => acc + Number(row.width), 0),
          }}
        >
          {Fotter ? Fotter : ""}
        </div>

        <div className="w-full flex justify-between">
          <div className="flex pt-2 items-center ">
            <div
              style={{
                fontSize: "11px",
                color: "#3b3a39",
                fontWeight: "600px",
              }}
            >
              Date :{" "}
            </div>

            <div
              style={{
                fontSize: "10px",
                color: "#3b3a39",
                fontWeight: "500px",
              }}
              className="pl-1"
            >
              {moment().format("YYYY-MM-DD HH:mm ")}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GeniusTableForReports;
